import * as React from "react";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Message from "./components/Message";
import Inbox from "./components/Inbox"
import Cookies from "js-cookie";
import spinner from "./images/spinner.gif";
import { checkUser } from "./utils/database";

function App() {
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cookie, setCookie] = useState("");

  useEffect(() => {
    const checkToken = () => {
      const accessToken = Cookies.get("accessToken");
      if (accessToken != cookie) setCookie(accessToken);
    };

    const accessToken = Cookies.get("accessToken");
    const accessTokenSecret = Cookies.get("accessTokenSecret");
    const accessProvider = Cookies.get("accessProvider")
    if(accessProvider == undefined){
      Cookies.remove("accessToken", { path: "" });
      Cookies.remove("accessTokenSecret", { path: "" });
    }

    checkUser(accessProvider,accessToken, accessTokenSecret)
      .then((userData) => {
        if (userData) {
          setLogged(true);
        } else {
          setLogged(false);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    const intervalId = setInterval(checkToken, 10);
    return () => clearInterval(intervalId);
  }, [cookie]);

  if (loading)
    return (
      <div className="container">
        <div className="spinner">
          <img src={spinner} />
        </div>
      </div>
    );

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="login"
          element={!logged ? <Login /> : <Navigate to="/dashboard" />}
        />
        <Route
          path="dashboard"
          element={logged ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route
          path="inbox"
          element={logged ? <Inbox /> : <Navigate to="/login" />}
        />
        <Route
          path="*"
          element={<Navigate to={logged ? "/dashboard" : "/login"} />}
        />
        <Route path=":userid" element={<Message />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
